import React, { Dispatch, SetStateAction } from 'react';
import { Button, FileUpload, Typography } from '@lamimed/pantheon';

import { sendToErrorTracking } from 'utils/sendToErrorTracking';

import { usePrescriptionUpload } from '../hooks/usePrescriptionUpload';
import * as S from '../styles';

interface UploadFilesProps {
  setCurrentStep: Dispatch<SetStateAction<number>>;
  loading: boolean;
}

export const UploadFiles: React.FC<UploadFilesProps> = ({
  setCurrentStep,
  loading,
}) => {
  const { fileUploadLoading, handleFileChange, handleFilesUpload, files } =
    usePrescriptionUpload();

  const isButtonDisabled = files.length === 0 || fileUploadLoading || loading;

  const onSubmit = () => {
    try {
      handleFilesUpload();

      setCurrentStep(2);
    } catch (error) {
      sendToErrorTracking({ error, where: 'uploadFiles', context: files });
    }
  };

  return (
    <>
      <S.TextContainer margin="medium">
        <Typography
          variant="heading_2"
          color="text__highlight"
          textAlign="center"
        >
          Carica le foto
        </Typography>
      </S.TextContainer>

      <S.TextContainer margin="medium">
        <Typography variant="body_text_2" textAlign="center">
          Se hai una prescrizione o una lista di esami puoi inviarcela
          caricandola o scattando una foto
        </Typography>
      </S.TextContainer>

      <FileUpload
        maxFilesAllowed={12}
        maxFileSize={5000}
        id="exami-upload"
        accept="image/*,.pdf"
        onChange={handleFileChange}
      />

      <S.ButtonsContainer>
        <Button extended disabled={isButtonDisabled} onClick={onSubmit}>
          Invia
        </Button>
      </S.ButtonsContainer>
    </>
  );
};
